export const PRICING_PLANS_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
//# sourceMappingURL=app-def-id.js.map